import {LegRecord} from "./JourneyDetails";
import {IRefundStatusResponse} from "./IRefundStatusJourney";

export class LookupJourneysRequest {
    bookingReference: string;
    email: string;
}

export interface LookupJourneyResponse {
    bookingDate: string,
    journeyList: Array<LookupJourneyResponseItem>,
    refundStatus: IRefundStatusResponse
}

export interface LookupJourneyResponseItem {
    purchaseID: string;
    journeyID: string;
    totalCost: number;
    saving: number;
    bookingReference: string;
    isAdvance: number;
    isCancelled: number;
    adults: number;
    children: number;
    railcard: any[];
    legRecordsOut?: LegRecord[];
    legRecordsRtn?: LegRecord[];
    deliveryMethodCode: string;
}